import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vModelText as _vModelText, resolveDirective as _resolveDirective, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/icon-play-video.svg'
import _imports_1 from '@/app/ui/assets/svg/trash-red.svg'
import _imports_2 from '@/app/ui/assets/svg/play-video.svg'
import _imports_3 from '@/app/ui/assets/svg/lion-parcel-red.svg'
import _imports_4 from '@/app/ui/assets/svg/user-avatar.svg'
import _imports_5 from '@/app/ui/assets/svg/x.svg'
import _imports_6 from '@/app/ui/assets/svg/chevron_circle.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2ede408e")

_pushScopeId("data-v-2ede408e")
const _hoisted_1 = { class: "w-full mx-auto rounded-xl bg-white" }
const _hoisted_2 = {
  key: 0,
  class: "p-4 bg-white border border-gray-300 rounded-t-lg"
}
const _hoisted_3 = { class: "flex flex-row gap-2 p-2 bg-gray-lp-1000 rounded-lg" }
const _hoisted_4 = {
  key: 0,
  class: "bg-white rounded-lg w-16 h-16 shadow p-2 relative"
}
const _hoisted_5 = {
  src: _imports_0,
  alt: "Play",
  class: "absolute  left-1/3 top-1/3 mt-1 ml-2px -translate-x-1/2 -translate-y-1/2 h-4 w-4 cursor-pointer pointer-events-none"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "trash",
  class: "w-5 h-5"
}, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "bg-white rounded-lg w-16 h-16 shadow p-2 relative"
}
const _hoisted_8 = {
  key: 0,
  class: "absolute bottom-6 w-4 h-4 transform left-1/2 -translate-x-1/2",
  src: _imports_2,
  alt: ""
}
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "trash",
  class: "w-5 h-5"
}, null, -1)
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = {
  key: 0,
  class: "absolute bottom-16 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-50 overflow-y-auto"
}
const _hoisted_12 = { class: "p-3" }
const _hoisted_13 = {
  key: 0,
  class: "p-3"
}
const _hoisted_14 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_15 = {
  key: 0,
  class: "w-6 h-6"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-full h-full object-contain",
  alt: "Lion Parcel"
}, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center overflow-hidden"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  class: "w-5 h-5 object-cover",
  alt: "User"
}, null, -1)
const _hoisted_19 = { class: "font-medium" }
const _hoisted_20 = {
  key: 1,
  class: "flex flex-row justify-between items-center gap-2 p-2 border border-gray-300 relative"
}
const _hoisted_21 = {
  key: 2,
  class: "flex flex-row justify-between items-center gap-2 p-2 border border-gray-300 relative"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "text-gray-lp-600 text-14px whitespace-nowrap font-normal" }
const _hoisted_24 = {
  ref: "cardContainer",
  class: "flex flex-grow items-center gap-2 overflow-hidden scroll-smooth",
  style: {"width":"26vw"}
}
const _hoisted_25 = { class: "w-full flex flex-col text-12px" }
const _hoisted_26 = { class: "font-bold" }
const _hoisted_27 = /*#__PURE__*/_createVNode("img", {
  src: _imports_6,
  alt: "next",
  width: "40",
  height: "40"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("img", {
  style: {"transform":"rotate(180deg)"},
  src: _imports_6,
  alt: "prev",
  width: "40",
  height: "40"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_AddTemplate = _resolveComponent("AddTemplate")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.uploadedFiles.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.previewFile, (file, index) => {
                return (_openBlock(), _createBlock("div", { key: index }, [
                  (file.data)
                    ? (_openBlock(), _createBlock("div", _hoisted_4, [
                        _withDirectives(_createVNode("img", _hoisted_5, null, 512), [
                          [_vShow, ['webm', 'mp4'].includes(file.ext)]
                        ]),
                        _createVNode("img", {
                          src: file.data,
                          class: "object-fill w-12 h-12 rounded-lg",
                          alt: "uploaded image"
                        }, null, 8, ["src"]),
                        _createVNode("div", {
                          onClick: () => _ctx.removeFile(index),
                          class: "absolute top-0 right-0 bg-white rounded-lg cursor-pointer"
                        }, [
                          _hoisted_6
                        ], 8, ["onClick"])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_7, [
                        _createVNode("img", {
                          src: 
                'data:image/svg+xml;utf8,' +
                  encodeURIComponent(
                    `<svg viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M9.69462 0H24L36 12V34.7926C36 37.6711 33.5088 40 30.4403 40H9.57031C6.49114 40 4 37.6711 4 34.7926V5.20733C3.99995 2.32878 6.61539 0 9.69462 0Z' fill='${_ctx.getFileColor(
                      file.name
                    )}'/><path d='M24.0257 8.16V0L36 12H28.0171C24.4248 12 23.8593 9.44 24.0257 8.16Z' fill='white' fill-opacity='0.3'/></svg>`
                  )
              ,
                          class: "object-fill w-12 h-12",
                          alt: "uploaded image"
                        }, null, 8, ["src"]),
                        (_ctx.isFileVideoMov(file.name))
                          ? (_openBlock(), _createBlock("img", _hoisted_8))
                          : (_openBlock(), _createBlock("span", {
                              key: 1,
                              class: " text-10px font-bold absolute bottom-3 transform left-1/2 -translate-x-1/2",
                              style: {
                color: _ctx.fileExt(file.name) === 'csv' ? '#626262' : '#ffffff'
              }
                            }, _toDisplayString(_ctx.fileExt(file.name).toUpperCase()), 5)),
                        _createVNode("div", {
                          onClick: () => _ctx.removeFile(index),
                          class: "absolute top-0 right-0 bg-white rounded-lg cursor-pointer"
                        }, [
                          _hoisted_9
                        ], 8, ["onClick"])
                      ]))
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_10, [
          (_ctx.showMentionList)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('pusatResolusi.chatBox.partnerList')), 1),
                (_ctx.isLoadingMention)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _createVNode(_component_Skeleton, { width: "80%" }),
                        _createVNode(_component_Skeleton, { width: "70%" }),
                        _createVNode(_component_Skeleton, { width: "80%" }),
                        _createVNode(_component_Skeleton, { width: "70%" })
                      ])
                    ]))
                  : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.users, (user, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: index,
                        onClick: ($event: any) => (_ctx.selectMention(user)),
                        class: "cursor-pointer hover:bg-gray-100 px-3 py-2 transition flex flex-row gap-4 mx-2"
                      }, [
                        (user.type === 'agent')
                          ? (_openBlock(), _createBlock("div", _hoisted_15, [
                              _hoisted_16
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_17, [
                              _hoisted_18
                            ])),
                        _createVNode("div", _hoisted_19, _toDisplayString(_ctx.showValueMention(user)), 1)
                      ], 8, ["onClick"]))
                    }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", {
            class: 
            `flex flex-row px-2 pt-4 pb-3 border overflow-y-auto border-gray-300 ${
              _ctx.uploadedFiles.length > 0 ? '' : 'rounded-t-lg'
            } flex-wrap gap-2`
          ,
            style: {"max-height":"5rem"}
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mentionSelected, (mention, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "bg-pink-lp-500 flex gap-1 text-red-lp-100 text-14px px-2 rounded whitespace-nowrap h-5"
              }, [
                _createVNode("div", null, " @ " + _toDisplayString(_ctx.showValueMention(mention)), 1),
                _createVNode("img", {
                  src: _imports_5,
                  class: "w-5 h-5 cursor-pointer opacity-50",
                  alt: "x",
                  onClick: () => _ctx.removeMention(mention.code)
                }, null, 8, ["onClick"])
              ]))
            }), 128)),
            _withDirectives(_createVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mentionQuery = $event)),
              placeholder: _ctx.$t('pusatResolusi.chatBox.insertAt'),
              class: "flex-grow outline-none text-12px",
              onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filterUsers && _ctx.filterUsers(...args)))
            }, null, 40, ["placeholder"]), [
              [_vModelText, _ctx.mentionQuery],
              [_directive_click_outside, _ctx.onBlurMention]
            ])
          ], 2)
        ])
      ]),
      (_ctx.isLoadingTemplate)
        ? (_openBlock(), _createBlock("div", _hoisted_20, [
            _createVNode(_component_Skeleton, { width: "100%" }),
            _createVNode(_component_Skeleton, { width: "100%" }),
            _createVNode(_component_Skeleton, { width: "100%" })
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_21, [
            (_ctx.templateChat.length === 0)
              ? (_openBlock(), _createBlock("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('pusatResolusi.chatBox.letsCreateMessage')), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_24, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.templateChat, (msg, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: "px-3 whitespace-nowrap py-1 bg-gray-100 rounded-full text-sm cursor-pointer hover:bg-gray-200 transition",
                  onClick: ($event: any) => (_ctx.insertTemplate(msg.templateMessage)),
                  onMouseenter: ($event: any) => (_ctx.toggleTooltip($event, msg.templateMessage)),
                  onMouseleave: ($event: any) => (_ctx.toggleTooltip($event, msg.templateMessage))
                }, [
                  _createVNode("p", null, _toDisplayString(_ctx.ellipsisText(msg.templateMessage, 20)), 1),
                  _createVNode(_component_OverlayPanel, {
                    ref: msg.templateMessage,
                    appendTo: "body",
                    class: "w-1/4",
                    style: {
              backgroundColor: '#4D4D4D',
              color: '#ffffff'
            }
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_25, [
                        _createVNode("div", _hoisted_26, _toDisplayString(msg.templateMessage), 1)
                      ])
                    ]),
                    _: 2
                  }, 1536)
                ], 40, ["onClick", "onMouseenter", "onMouseleave"]))
              }), 128))
            ], 512),
            (_ctx.showRightButton && _ctx.templateChat.length !== 0)
              ? (_openBlock(), _createBlock("div", {
                  key: 1,
                  class: "cursor-pointer absolute z-20",
                  style: {"top":"10%","right":"8.5rem"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollRight(true)))
                }, [
                  _hoisted_27
                ]))
              : _createCommentVNode("", true),
            (_ctx.showLeftButton)
              ? (_openBlock(), _createBlock("div", {
                  key: 2,
                  class: "cursor-pointer absolute left-0 z-20",
                  style: {"top":"10%"},
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollRight(false)))
                }, [
                  _hoisted_28
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: "text-red-lp-100 text-14px font-semibold ml-2 whitespace-nowrap cursor-pointer",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onAddTemplate && _ctx.onAddTemplate(...args)))
            }, _toDisplayString(_ctx.$t('pusatResolusi.chatBox.addTemplate')), 1)
          ])),
      _createVNode(_component_Editor, {
        modelValue: _ctx.modelValue,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
        countChar: _ctx.countChar,
        isSendButton: _ctx.isSendButton,
        isDisableSend: _ctx.isDisableSend,
        onFileUpload: _ctx.handleFileUpload,
        onSubmit: _ctx.sendChat
      }, null, 8, ["modelValue", "countChar", "isSendButton", "isDisableSend", "onFileUpload", "onSubmit"])
    ]),
    _createVNode(_component_AddTemplate, {
      key: _ctx.isAddTemplate,
      modelValue: _ctx.isAddTemplate,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isAddTemplate = $event)),
      data: _ctx.templateChat,
      onSuccess: _ctx.getTemplate
    }, null, 8, ["modelValue", "data", "onSuccess"])
  ], 64))
})